<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <van-form
        @submit="onSubmit"
    >
      <van-cell-group>
<!--        <van-field-->
<!--            v-model="formData.name"-->
<!--            :rules="[{ required: true, message: '请输入姓名' }]"-->
<!--            error-message-align="right"-->
<!--            label="姓名"-->
<!--            input-align="right"-->
<!--            clearable-->
<!--            placeholder="请输入姓名"-->
<!--        />-->

        <van-cell title="证件照片" :value="formData.pic.length+'/1'" />
        <div class="row">
          <PicUploader :fileList="formData.pic" :limit="1"
                       :name="'pic'"></PicUploader>
        </div>
        <div class="operate-desc-left">请上传符合正式规范的2寸证件照，蓝底、白底、灰底均可</div>
        <van-notice-bar
            v-show="formData.status == 1"
            wrapable
            :scrollable="false"
            text="证件照正在审核中，人工审核中预计7天，审核通过后，可以再次下载证书哦~"
        />

        <van-notice-bar
            v-show="formData.status == 3"
            wrapable
            :scrollable="false"
            :text="formData.admin_note"
        />

      </van-cell-group>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          {{formData.pic.length > 0 ? '修改' : '保存'}}
        </van-button>
      </div>
    </van-form>


  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import namekey from "../../../utils/namekey";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CertPersonPhoto',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showArea: false,
      showNamekey: false,
      areaList: {},
      namekeyList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        num: '',
        pic: [] // [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"},{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "证件照管理"
    that.fetch()
  },
  watch: {
  },
  destroyed() {
  },
  methods: {

    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (!this.formData.pic.length) {
          Toast('请选择证件照片');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/user/photoSubmit', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功')
        setTimeout(function(){
          rbLink({
            name: 'MyExperience',
            query: {
            }
          });
        },500);
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },

    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/photoData', {}, (res) => {
        that.formData = res.data;
      }, (res) => {

//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// CertPersonPhoto.vue?1a471086